import { inject } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalResult } from '../../../core/interfaces/modal-result';
import { GridDefaultBehaviorBase } from '../grid-default-behavior-base/grid-default-behavior-base';
import { ResultState } from '../../../core/enums/result-state.enum';
import { DialogRef } from '@progress/kendo-angular-dialog';

export class CustomDialog extends GridDefaultBehaviorBase {
  dialog = inject(DialogRef);

  private readonly _onCloseRequestedSource: Subject<ModalResult>;

  public dialogParameters: any;

  public width = 500;
  public top = 0;

  constructor() {
    super();
    this._onCloseRequestedSource = new Subject<ModalResult>();
  }

  public closeWithResultState(state: ResultState) {
    const result: ModalResult = { state };
    this.close(result);
  }

  public close(modalResult: ModalResult): void {
    this.dialog.close(modalResult);
    this._onCloseRequestedSource.next(modalResult);
  }
}
